/**
 * Line icons, inline.
 *
 * Drawn here rather than fetched: an icon font or a sprite sheet is a network
 * request in a client whose whole claim is that nothing leaves the browser.
 * Every glyph is one 24px viewBox on currentColor, so a theme recolours them by
 * recolouring their container and nothing else.
 */
const NS = "http://www.w3.org/2000/svg";

const PATHS = {
  // Stack, News, Paper Trail, Maybes. The same marks as the landing page's box tiles.
  inbox: ["M12 4l8 4-8 4-8-4z", "M4 12l8 4 8-4", "M4 16l8 4 8-4"],
  feed: ["M5 5h11v14H7a2 2 0 0 1-2-2z", "M16 9h3v8a2 2 0 0 1-2 2", "M8 9h5", "M8 13h5", "M8 16h3"],
  paper_trail: ["M6 3h8l4 4v14H6z", "M14 3v4h4", "M9 12h6", "M9 16h6"],
  screener: ["M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z", "M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .8-1 1.5V14", "M12 17h.01"],
  search: ["M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14z", "M20 20l-4-4"],
  flag: ["M6 21V4", "M6 5h11l-2 4 2 4H6"],
  bubble: ["M12 15V4", "M8 8l4-4 4 4", "M5 19h14"],
  clock: ["M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z", "M12 7v5l3 2"],
  exit: ["M15 4h4v16h-4", "M11 8l-4 4 4 4", "M7 12h8"],
  settings: ["M4 8h16", "M15 6v4", "M4 16h16", "M9 14v4"],
  download: ["M12 4v10", "M8 11l4 4 4-4", "M5 19h14"],
  compose: ["M4 20h4l10-10-4-4L4 16z", "M14 6l4 4", "M14 20h6"],
  reply: ["M10 8 4 12l6 4", "M4 12h7a8 8 0 0 1 8 8"],
  reply_all: ["M8 7 3 11l5 4", "M13 7 8 11l5 4", "M8 11h6a7 7 0 0 1 7 7"],
  forward: ["M14 8l6 4-6 4", "M20 12h-7a8 8 0 0 0-8 8"],
  paperclip: ["M18 10 11 17a3.5 3.5 0 0 1-5-5l8-8a2.5 2.5 0 0 1 4 4l-8 8"],
  close: ["M6 6l12 12", "M18 6 6 18"],
  spam: ["M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z", "M5.6 5.6l12.8 12.8"],
  trash: ["M5 7h14", "M9 7V4h6v3", "M7 7l1 13h8l1-13", "M11 11v6", "M13 11v6"],
} as const;

export type IconName = keyof typeof PATHS;

export function icon(name: IconName, size = 20): SVGSVGElement {
  const svg = document.createElementNS(NS, "svg");
  svg.setAttribute("viewBox", "0 0 24 24");
  svg.setAttribute("width", String(size));
  svg.setAttribute("height", String(size));
  svg.setAttribute("fill", "none");
  svg.setAttribute("stroke", "currentColor");
  svg.setAttribute("stroke-width", "1.8");
  svg.setAttribute("stroke-linecap", "round");
  svg.setAttribute("stroke-linejoin", "round");
  svg.setAttribute("aria-hidden", "true");
  for (const d of PATHS[name]) {
    const path = document.createElementNS(NS, "path");
    path.setAttribute("d", d);
    svg.append(path);
  }
  return svg;
}
